import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function AnimatedSection({
  children,
  className = '',
  id
}: AnimatedSectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`py-10 sm:py-16 md:py-24 ${className}`} data-id="element-328">
      {children}
    </motion.section>;
}